:host {
    display: contents;
}